:host {
    display: contents;
}